var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-tile-layer',{staticClass:"base-tile-filter",attrs:{"url":_vm.baseTileUrl(),"layer-type":"base"}})
}
var staticRenderFns = []

export { render, staticRenderFns }